import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-login-outlet',
  templateUrl: './login-outlet.component.html',
  styleUrls: ['./login-outlet.component.css']
})
export class LoginOutletComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
